import {
  //
  ADD_VACCINATION,
  ADD_VACCINATION_FAILURE,
  ADD_VACCINATION_SUCCESS,
  //
  DELETE_VACCINATION,
  DELETE_VACCINATION_FAILURE,
  DELETE_VACCINATION_SUCCESS,
  //
  EDIT_VACCINATION,
  EDIT_VACCINATION_FAILURE,
  EDIT_VACCINATION_SUCCESS,
  //
  FETCH_VACCINATION,
  FETCH_VACCINATION_FAILURE,
  FETCH_VACCINATION_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_VACCINATION_MODAL,
} from "./constants";

// List
export const fetchVaccination = (payload, onSuccess) => ({
  type: FETCH_VACCINATION,
  payload,
  onSuccess,
});
export const fetchVaccinationSuccess = (payload) => ({
  type: FETCH_VACCINATION_SUCCESS,
  payload,
});
export const fetchVaccinationFailure = (payload) => ({
  type: FETCH_VACCINATION_FAILURE,
  payload,
});
// View
export const getViewData = (payload, onSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addVaccination = (payload, onAdd) => ({
  type: ADD_VACCINATION,
  payload,
  onAdd,
});
export const addVaccinationSuccess = (payload) => ({
  type: ADD_VACCINATION_SUCCESS,
  payload,
});
export const addVaccinationFailure = (payload) => ({
  type: ADD_VACCINATION_FAILURE,
  payload,
});
// EDIT
export const editVaccination = (payload, onEdit) => ({
  type: EDIT_VACCINATION,
  payload,
  onEdit,
});
export const editVaccinationSuccess = (payload, onEdit) => ({
  type: EDIT_VACCINATION_SUCCESS,
  payload,
});
export const editVaccinationFailure = (payload) => ({
  type: EDIT_VACCINATION_FAILURE,
  payload,
});
// DELETE
export const deleteVaccination = (payload, onDelete) => ({
  type: DELETE_VACCINATION,
  payload,
  onDelete,
});
export const deleteVaccinationSuccess = (payload) => ({
  type: DELETE_VACCINATION_SUCCESS,
  payload,
});
export const deleteVaccinationFailure = (payload) => ({
  type: DELETE_VACCINATION_FAILURE,
  payload,
});

// Modal
export const toggleVaccinationModal = (payload) => ({
  type: TOGGLE_VACCINATION_MODAL,
  payload,
});
